export const CATEGORY_LIST = {
	is_all_claims: "All Claims",
	is_check_status_requested: "Check Status Requested",
	is_closure_letter_required: "Closure Letter Required",
	is_closure_letter_completed: "Closure Letter Completed",
	is_move_to_history: "Bin"
};
